import { toast } from "sonner";
import { getErrorMessage, getRequestId } from "./error";

/**
 * Show an error toast for an unknown error. When the error carries a
 * `requestId` (set by the API client from the `X-Request-Id` response header),
 * include it as a description so users can quote it when reporting issues.
 */
export function toastError(err: unknown, fallback = "Request failed") {
  const message = getErrorMessage(err, fallback);
  const requestId = getRequestId(err);
  return toast.error(
    message,
    requestId ? { description: `Request ID: ${requestId}` } : undefined,
  );
}
